import { render, staticRenderFns } from "./announcementList.vue?vue&type=template&id=6c8abcb6&"
import script from "./announcementList.vue?vue&type=script&lang=js&"
export * from "./announcementList.vue?vue&type=script&lang=js&"
import style0 from "./announcementList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c8abcb6')) {
      api.createRecord('6c8abcb6', component.options)
    } else {
      api.reload('6c8abcb6', component.options)
    }
    module.hot.accept("./announcementList.vue?vue&type=template&id=6c8abcb6&", function () {
      api.rerender('6c8abcb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/announcement/announcementList.vue"
export default component.exports